import 'phaser';
import CanvasInputPlugin from 'phaser3-rex-plugins/plugins/canvasinput-plugin';

/**
 * Returns the base Phaser game configuration.
 * Matches the standard config used across V3.1 sims (e.g. buzzer-frizer,
 * basketball-game) — no zoom, no render overrides. Earlier HiDPI hacks
 * (DPR-based scale.zoom) caused blurring across the scene; the safe
 * default ships sharp rendering on every device the team has tested.
 */
export default function getConfig() {
  return {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: 1280,
    height: 720,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    backgroundColor: 0xffffff,
    scene: [], // scenes are added manually after Game instantiation
    dom: {
      createContainer: true,
    },
    zoom: 1,
    fps: { target: 60 },
    physics: {
      default: 'arcade',
    },
    audio: {
      disableWebAudio: false,
    },
    plugins: {
      global: [
        {
          key: 'rexCanvasInputPlugin',
          plugin: CanvasInputPlugin,
          start: true,
        },
      ],
    },
  };
}
